/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;

      if ( $( '.related' ).length ) {
        $( '.related-slider__slider' ).find( '.product' ).each( function( index, element ) {
          $( element ).addClass( 'splide__slide' );
        } );
        $( '.related-slider' ).each( function( index, element ) {
          const relatedSlider = new Splide( element, {
            type: 'loop',
            gap: '2rem',
            perPage: 3,
            perMove: 1,
            pagination: false,
            speed: 800,
            breakpoints: {
              768: {
                perPage: 1,
                gap: '1rem',
              },
            },
          } );
          relatedSlider.on( 'overflow', function( isOverflow ) {
            if ( isOverflow ) {
              //
            } else {
              relatedSlider.options = {
                type: 'slide',
                arrows: isOverflow,
                drag: isOverflow,
              };
            }
          } );
          relatedSlider.mount( {} );
        } );
      }
      if ( $( '#splide-gallery' ).length && $( '#splide-gallery__nav' ).length ) {
        const gallery = new Splide( '#splide-gallery', {
          type: 'loop',
          perPage: 1,
          gap: '1rem',
          arrows: false,
          pagination: false,
        } );

        const galleryNav = new Splide( '#splide-gallery__nav', {
          type: 'slide',
          perPage: 5,
          arrows: false,
          pagination: false,
          isNavigation: true,
          gap: '12px',
        } );

        galleryNav.on( 'overflow', function( isOverflow ) {
          galleryNav.go( 0 );
          galleryNav.options = {
            drag: isOverflow,
            clones: isOverflow ? undefined : 0,
          };
        } );

        gallery.sync( galleryNav );
        gallery.mount();
        galleryNav.mount();
      }
      // increment quantity
      $( 'body' ).on( 'click', '.increment-qty', function( e ) {
        e.preventDefault();
        const qtyInput = $( this ).parent( '.llwc-quantity' ).siblings( 'input.qty' );
        const currentVal = parseInt( qtyInput.val() );
        const maxVal = parseInt( qtyInput.attr( 'max' ) );
        if ( !isNaN( maxVal ) && currentVal >= maxVal ) {
          return;
        }
        qtyInput.val( currentVal + 1 );
        $( '[name=update_cart]' ).prop( {'disabled': false, 'aria-disabled': false} );
      } );
      // decrement quantity
      $( 'body' ).on( 'click', '.decrement-qty', function( e ) {
        e.preventDefault();
        const qtyInput = $( this ).parent( '.llwc-quantity' ).siblings( 'input.qty' );
        const currentVal = parseInt( qtyInput.val() );
        const minVal = parseInt( qtyInput.attr( 'min' ) );
        if ( currentVal <= minVal ) {
          return;
        }
        qtyInput.val( currentVal - 1 );
        $( '[name=update_cart]' ).prop( {'disabled': false, 'aria-disabled': false} );
      } );
      // submit shop filter form when a checkbox is clicked
      $( '#woocommerce-shop-filter input' ).on( 'change', function( e ) {
        e.preventDefault();
        $( 'form#woocommerce-shop-filter' ).submit();
      } );
      // if a shop filter has a selected input then start with it open
      $( 'ul.woocommerce-shop__filter-dropdown' ).each( function() {
        if ( $( this ).find( 'input:checked' ).length ) {
          $( this ).prev( 'button' ).trigger( 'click' );
        }
      } );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'woocommerce', COMPONENT );
} )( app );
